import { GlideAsyncThunk } from "./action-thunk";
import { updateUser, updateUserFlags } from "../reducers/user-data";
import { saveUserUpdates } from "../lib/firebase-functions";
import { MoveOrgInUserBody, UserFlags } from "common/firebase-function-types";
import { isUserData, Organization } from "common/Database";
import { moveItemInArray } from "common/Support";
import { getAppFacilities } from "webapp/lib/app-renderer";
import { sortOrganizationsById } from "reducers/organizations";

export function setLastAcceptedTermsOfService(version: number): GlideAsyncThunk {
    return async dispatch => {
        const updates: Partial<UserFlags> = { lastAcceptedTermsOfService: version };
        dispatch(updateUserFlags(updates));
        await saveUserUpdates({ flags: updates as UserFlags }, {});
    };
}

export function setBuilderTheme(
    theme: "light" | "dark",
    useSystemTheme: boolean,
    viaUserInteraction: boolean
): GlideAsyncThunk {
    return async dispatch => {
        const updates: Partial<UserFlags> = { builderTheme: theme, useSystemTheme };
        dispatch(updateUserFlags(updates));
        try {
            if (viaUserInteraction) {
                await saveUserUpdates({ flags: updates as UserFlags }, {});
            }
        } catch {
            // Sometimes the theme can change when we do not have a valid user—
            // either we are logged out, or the theme changes very early in the builder
            // lifecycle. If we cannot save the theme to the user, we silently fail.
            return;
        }
    };
}

export function reorderUserOrgs(sourceOrg: Organization, destinationOrg: Organization | undefined): GlideAsyncThunk {
    return async (dispatch, getStore) => {
        const store = getStore();
        const user = store.userData;
        if (!isUserData(user)) return;

        const newIDs = moveItemInArray(user.orgUserIDs, sourceOrg.id, destinationOrg?.id);
        if (newIDs === undefined) return;

        dispatch(sortOrganizationsById(newIDs));
        dispatch(
            updateUser({
                ...user,
                orgUserIDs: newIDs,
            })
        );

        const body: MoveOrgInUserBody = {
            orgID: sourceOrg.id,
            afterOrgID: destinationOrg?.id,
        };
        await getAppFacilities().callAuthCloudFunction("moveOrgInUser", body);
    };
}
